import { render } from "./Philatelie.vue?vue&type=template&id=1d5cc404&ts=true"
import script from "./Philatelie.vue?vue&type=script&lang=ts"
export * from "./Philatelie.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__